import React from "react";
import GlitchText from "./GlitchText";

export default function TopNavigation({ onNavClick }) {
  const navItems = ["HOME", "COMPETITIONS", "ABOUT", "CONTACT", "LEADERBOARD", "MERCHANDISE", "RSVP"];

  return (
    <div className="top-navigation">
      {navItems.map((item, idx) => (
        <GlitchText
          key={idx}
          text={item}
          onClick={() => onNavClick(item)}
          style={{ cursor: "pointer" }}
        />
      ))}
    </div>
  );
}
